var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#2F4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.279892 0.93624C0.488396 0.764371 0.7764 0.719869 1.0284 0.821149L23.5288 10.0285C23.8063 10.142 23.9923 10.4136 23.9998 10.7205C24.0073 11.0274 23.8363 11.3083 23.5633 11.4372L16.4996 14.7733L0.749399 1.53318L13.4996 16.1897V23.7842L8.17752 18.7033L4.06445 20.6445C3.96395 20.6905 3.85595 20.7151 3.74944 20.7151C3.62944 20.7151 3.50794 20.6844 3.39994 20.6261C3.19144 20.514 3.04893 20.3099 3.00993 20.0736L0.0098877 1.65901C-0.0336132 1.3874 0.068388 1.10964 0.279892 0.93624Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2cef2736e86094936d9cfae9eb753e41.svg";
export { ForwardRef as ReactComponent };